// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
@media (max-width: 37.4rem) {
  .style_hide-sm__X3Pm9 {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__yua_f {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__QO7LK {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__rOUJy {
    display: none !important;
  }
}
.style_container__ts9to {
  display: flex;
  padding: 1rem 1rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 4.25rem;
}
.style_titleContainer__uffni {
  display: flex;
  flex-direction: column;
  font-size: 1.25rem;
}
.style_header___JOoI {
  margin: 0;
  padding: 0;
}
.style_title__Gu8w_ {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1.75rem;
  margin: 0.25rem 0;
}
.style_logo__XD32n {
  margin-right: 0.5rem;
}
.style_refreshContainer__oE0bY {
  position: relative;
  height: 1.75rem;
  opacity: 0.8;
}
.style_refreshIndicator__xG27j {
  width: 2.5rem;
}
.style_breadcrumbContainer__jWuEN {
  display: flex;
  flex-direction: row;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/SectionTitle/style.less","webpack://./app/resources/styles/media.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;ACNF;EACE;IACE,wBAAA;EDQF;AACF;ACLA;EACE;IACE,wBAAA;EDOF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;AA7BA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AA+BJ;AA5BA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AA8BJ;AA3BA;EACI,SAAA;EACA,UAAA;AA6BJ;AA1BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AA4BF;AAzBA;EACE,oBAAA;AA2BF;AAxBA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AA0BJ;AAvBA;EACE,aAAA;AAyBF;AAtBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAwBJ","sourcesContent":["@import \"../../resources/styles/colors\";\n@import \"../../resources/styles/media\";\n\n.container {\n    display: flex;\n    padding: 1rem 1rem;\n    align-items: center;\n    flex-wrap: wrap; // Need this to wrap for mobile.\n    justify-content: space-between;\n    min-height: 4.25rem;\n}\n\n.titleContainer {\n    display: flex;\n    flex-direction: column; // Needed so we wrap release links above title.\n    font-size: 1.25rem;\n}\n\n.header {\n    margin: 0;\n    padding: 0;\n}\n\n.title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: 1.75rem; // 28px - this matches our SectionTitle's RefreshIndicator's size.\n  margin: 0.25rem 0;\n}\n\n.logo {\n  margin-right: .5rem;\n}\n\n.refreshContainer {\n    position: relative;\n    height: 1.75rem; // Needed, or it can throw out the height of our SectionTitle.\n    opacity: 0.8;\n}\n\n.refreshIndicator {\n  width: 2.5rem;\n}\n\n.breadcrumbContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n","//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__X3Pm9`,
	"hideSm": `style_hide-sm__X3Pm9`,
	"visible-sm": `style_visible-sm__yua_f`,
	"visibleSm": `style_visible-sm__yua_f`,
	"hide-md": `style_hide-md__QO7LK`,
	"hideMd": `style_hide-md__QO7LK`,
	"visible-md": `style_visible-md__rOUJy`,
	"visibleMd": `style_visible-md__rOUJy`,
	"container": `style_container__ts9to`,
	"titleContainer": `style_titleContainer__uffni`,
	"header": `style_header___JOoI`,
	"title": `style_title__Gu8w_`,
	"logo": `style_logo__XD32n`,
	"refreshContainer": `style_refreshContainer__oE0bY`,
	"refreshIndicator": `style_refreshIndicator__xG27j`,
	"breadcrumbContainer": `style_breadcrumbContainer__jWuEN`
};
module.exports = ___CSS_LOADER_EXPORT___;
